<template>
    <div ref="modalContent" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog" :class="[
            'modal-dialog',
            sizeClass
            ]"
            role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{title}}</h5>
                    <button v-if="hasCloseButton" type="button" class="close" @click="hide" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="content"></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    'name': 'BootstrapModal',
    'props': {
        'title': {
            'type': String,
            'required': true
        },
        'hasCloseButton': {
            'type': Boolean,
            'default': true
        },
        'sizeClass': {
            'type': String,
            'default': ''
        }
    },
    mounted () {
    },
    'methods': {
        show (callback) {
            return new Promise((resolve) => {
                $(this.$refs.modalContent).one('shown.bs.modal', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    resolve();
                });

                $(this.$refs.modalContent).modal('show');
            });
        },
        hide (callback) {
            return new Promise((resolve) => {
                $(this.$refs.modalContent).one('hidden.bs.modal', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    resolve();
                });

                $(this.$refs.modalContent).modal('hide');
            });
        }
    }
};

</script>

<style>

</style>
